module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./bower_components/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf
 ** module id = 198
 ** module chunks = 1
 **/